import React from 'react';
import PropTypes from 'prop-types';

/**
 * Picture component with WebP support and fallback
 * Automatically serves .webp if available, falls back to original format
 */
const Picture = ({ src, alt, className, width, height, fetchPriority, loading = 'lazy', ...props }) => {
  const webpSrc = src.replace(/\.(jpg|jpeg|png)(\?.*)?$/i, '.webp$2');

  return (
    <picture>
      <source srcSet={webpSrc} type="image/webp" />
      <img
        src={src}
        alt={alt}
        className={className}
        width={width}
        height={height}
        loading={loading}
        // eslint-disable-next-line react/no-unknown-property
        fetchpriority={fetchPriority}
        {...props}
      />
    </picture>
  );
};

Picture.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  fetchPriority: PropTypes.string,
  loading: PropTypes.string,
};

export default Picture;
